<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Stany materiałów</span>
        <h3 class="page-title">Lista stanów materiałów - materiały i kolory</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          @click.prevent="openImportPopup"
          theme="primary"
          class="mr-2">
          <i class="material-icons">
            cloud_upload
          </i>
          Importuj
        </d-button>

        <d-button
          theme="secondary"
          class="ml-2"
          :disabled="exportInProgress"
          @click.prevent="exportMaterialsStock">
          <i
            v-if="!exportInProgress"
            class="material-icons">
            cloud_download
          </i>
          <div
            v-if="exportInProgress"
            class="spinner-border spinner-border-sm"
            role="status"></div>
          Eksportuj
        </d-button>
      </d-col>
    </d-row>

    <d-row
      v-if="loaded"
      style="width: 100%;"
      class="d-flex ml-0 mb-3 page-filters">
      <validation-observer
        ref="materials-stock-filters-form"
        tag="form"
        style="width: 100%;"
        class="d-flex">
        <d-input
          placeholder="Podaj nazwę produktu"
          v-model="filters.search" />

        <d-button
          theme="info"
          outline
          class="text-nowrap ml-2"
          @click.prevent="validateFiltersForm">Szukaj</d-button>

        <d-button
          theme="danger"
          outline
          class="text-nowrap ml-2"
          @click.prevent="clearFilters">Resetuj filtry</d-button>
      </validation-observer>
    </d-row>

    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0">Nazwa materiału</th>
            <th scope="col" class="border-0">Kolory</th>
            <th scope="col" class="border-0">Akcje</th>
          </tr>
        </thead>
        <tbody v-if="loaded">
          <tr
            v-for="(material, index) of materials"
            :key="'material-' + index">
            <td class="align-middle">
              {{ material.name }}
            </td>
            <td class="align-middle py-0">
              <table class="table table-sm mb-0" style="margin-top: -1px;">
                <thead>
                  <tr>
                    <th class="w-25">Kolor</th>
                    <th class="w-25">Stan:</th>
                    <th class="w-25">Dostępne:</th>
                    <th class="w-25">W zamówieniach:</th>
                  </tr>
                </thead>
                <tfoot v-if="material.colors.length > 5">
                  <a
                    v-if="!expandedColors[material.id]"
                    href="#"
                    @click.prevent="openList(material.id)">
                    Pokaż wszystkie
                  </a>
                  <a
                    v-if="expandedColors[material.id]"
                    href="#"
                    @click.prevent="closeList(material.id)">
                    Zwiń listę
                  </a>
                </tfoot>
                <tbody>
                  <tr
                    v-for="(color, subindex) of material.colors"
                    :key="'material-color-' + index + '-' + subindex"
                    :hidden="!(subindex < 5 || expandedColors[material.id])"
                    class="my-1">
                    <td>{{ color.name }}</td>
                    <td>{{ color.stock_bolt }} ({{ color.stock_cm }} cm<sup>2</sup>)</td>
                    <td>{{ color.stock_bolt_available }} ({{ color.stock_cm_available }} cm<sup>2</sup>)</td>
                    <td>{{ color.sum_order_products_usage_bolt }} ({{ color.sum_order_products_usage_cm }} cm<sup>2</sup>)</td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td
              class="align-middle"
              style="width: 100px;">
              <d-button
                theme="primary"
                @click.native="$router.push('/stany-materialow/materialy-i-kolory/edycja/' + material.id)"
                class="mr-2"
                title="Aktualizuj">
                <i class="material-icons">edit</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="materials.length === 0">
            <td
              colspan="5"
              class="text-center">
              Brak materiałów do wyświetlenia&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!loaded" class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>
    </d-card>

    <pagination
      :meta-data="paginationMetaData"
      :initial-page="currentPage" />

    <d-modal
      v-if="showImportPopup"
      @close="closeImportPopup">
      <d-modal-header>
        <d-modal-title>
          Importuj plik z materiałami
        </d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <d-form>
          <validation-observer ref="import-form" tag="form">
            <div class="form-group">
              <label for="name">
                Importowany plik:
              </label>

              <validation-provider
                rules="required"
                name="file"
                v-slot="{ errors }">
                <file-input
                  :onChange="setNewFile"
                  id="inputFileImport" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </validation-observer>
        </d-form>
      </d-modal-body>
      <d-modal-footer>
        <d-button
          class="ml-0"
          theme="danger"
          :disabled="importInProgress"
          @click.prevent="closeImportPopup">
          Anuluj
        </d-button>
        <d-button
          class="ml-auto"
          theme="success"
          :disabled="importInProgress"
          @click.prevent="validateImportForm">
          <div
            v-if="importInProgress"
            class="spinner-border spinner-border-sm"
            role="status"></div>
          Importuj
        </d-button>
      </d-modal-footer>
    </d-modal>
  </d-container>
</template>

<script>
import debounce from 'lodash.debounce';
import jsonToFormData from 'json-form-data';
import FormUtils from './../utils/FormUtils.js';
import HasFilters from './../mixins/HasFilters.vue';
import HasPagination from './../mixins/HasPagination.vue';
import ListUtils from './../utils/ListUtils.js';
import Pagination from './../components/common/Pagination.vue';
import Vue from 'vue';

export default {
  name: 'materials-stock-colors',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    'pagination': Pagination
  },
  data() {
    return {
      materials: [],
      loaded: false,
      loadError: false,
      filters: {
        search: ''
      },
      expandedColors: [],
      exportInProgress: false,
      importFile: null,
      importInProgress: false,
      showImportPopup: false
    };
  },
  mounted () {
    this.loadFilteredData();
  },
  methods: {
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.$emit('view-filters-save');
      this.loadFilteredData();
    }, 250),
    loadFilteredData () {
      let where = {
        search: this.filters.search
      };

      ListUtils.loadItemsData(this, {
        endpoint: '/materials-stock/materials/items?page=' + this.currentPage,
        listField: 'materials',
        pagination: true,
        params: {
          where
        }
      });
    },
    clearFilters () {
      this.loaded = false;
      this.loadError = false;
      this.filters = {
        search: ''
      };

      this.loadFilteredData();
      this.$bus.$emit('view-filters-reset');
    },
    validateFiltersForm () {
      this.$bus.$emit('pagination-reset');
      FormUtils.validate(this.$refs['materials-stock-filters-form'], this.debouncedLoadFilteredData);
    },
    openImportPopup () {
      this.showImportPopup = true;
    },
    closeImportPopup () {
      this.importFile = null;
      this.showImportPopup = false;
    },
    validateImportForm () {
      FormUtils.validate(this.$refs['import-form'], this.import);
    },
    setNewFile (event) {
      this.importFile = event.target.files[0];
    },
    import () {
      this.importInProgress = true;

      let importData = {
        file: this.importFile
      };

      this.$http.request({
        method: 'POST',
        url: '/materials-stock/materials/import',
        headers: { 'Content-Type': undefined },
        transformRequest (data) {
          let dataToSend = jsonToFormData(data);
          return dataToSend;
        },
        data: importData
      }).then((response) => {
        if (response.data.success) {
          Vue.swal({
            title: 'Zaimportowano materiały',
            html: 'Udało się pomyślnie zaimportować materiały',
            type: 'success',
            confirmButtonText: 'OK',
            buttonsStyling: true,
            timer: 2000
          });
        }

        this.closeImportPopup();
        this.clearFilters();
        this.importInProgress = false;
      }).catch(error => {
        console.log(error);
        this.closeImportPopup();

        Vue.swal({
          title: 'Import nie powiódł się',
          html: 'Operacja importu stanów materiałów produktów nie powiodła się. Spróbuj ponownie...',
          type: 'warning',
          confirmButtonText: 'OK',
          buttonsStyling: true
        });
        this.importInProgress = false;
      });
    },
    exportMaterialsStock () {
      this.exportInProgress = true;

      this.$http.post('/materials-stock/materials/export', {}, {
        responseType: 'blob'
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'materialy.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.exportInProgress = false;
      }).catch(error => {
        console.log(error);
        Vue.swal({
          title: 'Eksport nie powiódł się',
          html: 'Wyeksportowanie materiałów nie powiodło się. Spróbuj ponownie...',
          type: 'warning',
          confirmButtonText: 'OK',
          buttonsStyling: true
        });
        this.exportInProgress = false;
      });
    },
    openList (materialID) {
      Vue.set(this.expandedColors, materialID, true);
    },
    closeList (materialID) {
      Vue.set(this.expandedColors, materialID, false);
    }
  }
};
</script>

